module.exports = __webpack_public_path__ + "static/media/creativeschool_5_t.03dba77a.jpg";